module.exports = __webpack_public_path__ + "img/1024.2081e7c0.svg";